"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BaseProviderFormProps } from "@/components/settings/data-providers/provider-forms/base-provider-form";
import { InstructionsWrapper } from "@/components/settings/data-providers/provider-forms/instructions-wrapper";
import { FormPasswordInput } from "@/components/ui/password-input";
import { FormMultiSelect, FormSelect } from "@/components/ui/select";
import { createCondition, WithCondition } from "@/components/ui/with-condition";
import { ProviderType } from "@/types/dataProvider";
export const AsanaProviderForm = t0 => {
  const $ = _c(46);
  const {
    form,
    isCreating,
    currentStep,
    providerData,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== providerData?.projectOptions) {
    t2 = providerData?.projectOptions as {
      label: string;
      value: string;
    }[] || [];
    $[0] = providerData?.projectOptions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const projectOptions = t2;
  const projectOptionsLoading = Boolean(providerData?.projectOptionsLoading);
  let t3;
  if ($[2] !== providerData?.workspaceOptions) {
    t3 = providerData?.workspaceOptions as {
      label: string;
      value: string;
    }[] || [];
    $[2] = providerData?.workspaceOptions;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const workspaceOptions = t3;
  let t4;
  if ($[4] !== currentStep || $[5] !== isEditMode) {
    t4 = createCondition.or(createCondition.truthy(currentStep === 0), createCondition.truthy(isEditMode));
    $[4] = currentStep;
    $[5] = isEditMode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ol><li>Sign in to{" "}<a className="text-primary underline" href="https://app.asana.com/0/my-apps" rel="noopener noreferrer" target="_blank">Asana Developer Console</a>.</li><li>Create a personal access token or copy an existing token from the token list.</li><li>Paste the token below and continue to verify your connection.</li></ol>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isEditMode) {
    t6 = <InstructionsWrapper accordion={isEditMode} title="How to get your Asana Personal Access Token (PAT):">{t5}</InstructionsWrapper>;
    $[8] = isEditMode;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = isEditMode ? "Personal Access Token (optional)" : "Personal Access Token";
  const t8 = isEditMode ? "Enter a new PAT only if rotating credentials" : "Enter Asana PAT";
  let t9;
  if ($[10] !== form || $[11] !== isCreating || $[12] !== t7 || $[13] !== t8) {
    t9 = <FormPasswordInput autoComplete="new-password" disabled={isCreating} form={form} label={t7} name="data.credentials.personalAccessToken" placeholder={t8} type="password" />;
    $[10] = form;
    $[11] = isCreating;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t9) {
    t10 = <WithCondition condition={t4}>{t6}{t9}</WithCondition>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== currentStep || $[20] !== isEditMode) {
    t11 = createCondition.or(createCondition.truthy(currentStep === 1), createCondition.truthy(isEditMode));
    $[19] = currentStep;
    $[20] = isEditMode;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      className: "w-full"
    };
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== form || $[24] !== isCreating || $[25] !== workspaceOptions) {
    t13 = <FormSelect disabled={isCreating} form={form} label="Workspace" name={"data.credentials.workspaceGid" as any} options={workspaceOptions} placeholder="Select Asana Workspace" triggerProps={t12} />;
    $[23] = form;
    $[24] = isCreating;
    $[25] = workspaceOptions;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t11 || $[28] !== t13) {
    t14 = <WithCondition condition={t11}>{t13}</WithCondition>;
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== currentStep || $[31] !== isEditMode) {
    t15 = createCondition.or(createCondition.truthy(currentStep === 2), createCondition.truthy(isEditMode));
    $[30] = currentStep;
    $[31] = isEditMode;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      className: "w-full"
    };
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== form || $[35] !== isCreating || $[36] !== projectOptions || $[37] !== projectOptionsLoading) {
    t17 = <FormMultiSelect disabled={isCreating} form={form} isLoading={projectOptionsLoading} label="Projects" loadingText="Loading Asana projects..." name={"data.projectIds" as any} options={projectOptions} placeholder="Select Asana projects" triggerProps={t16} />;
    $[34] = form;
    $[35] = isCreating;
    $[36] = projectOptions;
    $[37] = projectOptionsLoading;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t15 || $[40] !== t17) {
    t18 = <WithCondition condition={t15}>{t17}</WithCondition>;
    $[39] = t15;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t10 || $[43] !== t14 || $[44] !== t18) {
    t19 = <>{t10}{t14}{t18}</>;
    $[42] = t10;
    $[43] = t14;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
};
(AsanaProviderForm as any).providerType = ProviderType.ASANA;